import { orderXClient } from '@/service/client'
import {
  CreateApiKeyRequest,
  CreateApiKeyResponse,
  ListApiKeysResponse,
  RevokeApiKeyRequest,
  RevokeApiKeyResponse,
  ServerMessage,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

// A routine refusal (bad password, cap, unknown key) comes back as success: false with an
// error_message — rejected here with that message so callers can branch on its prefix. Only
// real faults (incl. RateLimited) arrive as a transport error.

export async function listApiKeys() {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { listApiKeys: {} })
    const response = data.listApiKeysResponse as ListApiKeysResponse
    if (!response?.success) {
      return Promise.reject({
        status: 400,
        message: response?.errorMessage || 'Failed to load API keys',
      })
    }
    return response
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}

export async function createApiKey(payload: CreateApiKeyRequest) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { createApiKey: payload })
    const response = data.createApiKeyResponse as CreateApiKeyResponse
    if (!response?.success || !response.apiKey) {
      return Promise.reject({
        status: 400,
        message: response?.errorMessage || 'Failed to create API key',
      })
    }
    return response
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}

export async function revokeApiKey(payload: RevokeApiKeyRequest) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { revokeApiKey: payload })
    const response = data.revokeApiKeyResponse as RevokeApiKeyResponse
    // success: false means the key isn't this user's — never treat it as revoked.
    if (!response?.success) {
      return Promise.reject({
        status: 400,
        message: response?.errorMessage || 'Failed to revoke API key',
      })
    }
    return response
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}
